import * as React from 'react';

//components 
import { FluidSection } from 'components/FluidSection/FluidSection';
import ProviderCard from './ProviderCard';

const ProviderCardSection = (props) => {
    return (
        <FluidSection style={{ marginBottom: 10 }} sectionMinWidth={140} sectionMaxWidth={157}>
            { props.services && props.services.length > 0 && props.providers &&
                props.providers.map((provider)=>{
                    let servicePrices = [];
                    servicePrices = props.services.map(service => {
                        if (service.provider === provider.uid){
                            return service && service.price;
                        }
                    })
                    servicePrices = servicePrices.filter(price => price) // remove null objects from list
                    const lowestPrice = Math.min(...servicePrices);
                        return (
                            <ProviderCard
                                provider={provider}
                                lowestPrice={lowestPrice}
                            />
                        );
                })
            }
        </FluidSection>
    );
};

export default ProviderCardSection;


// WEBPACK FOOTER //
// ./src/js/components/ProviderCardSection/index.js